import { fetchData } from "../../Helpers";

export const DETAILS_REFETCH_INVERVAL = 1000 * 60 * 5;
export const DETAILS_STALE_TIME = 1000 * 60 * 5.5;
export const DETAILS_CACHE_TIME = Infinity;

export async function loginByToken(token) {
  const payload = {
    withToken: true,
  };

  let response = await fetch(
    import.meta.env.VITE_API_URL + "/consumer/details",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(payload),
    }
  );

  let res = await response.json();

  if (res.status.success) {
    if (res.data.token) {
      localStorage.setItem("token", JSON.stringify(res.data.token));
    }
    return res.data;
  }
  return {};
}

export async function getUserDetails() {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/consumer/details",
    successCallback: resObj => {
      const { consumer } = resObj.data;
      const { dob, emailAddress, firstName, lastName, ...filteredConsumer } =
        consumer;
      const filteredUserDetails = {
        ...resObj.data,
        consumer: filteredConsumer,
      };
      if (
        !dataLayer.some(e => e.event === "login") &&
        !localStorage.getItem("loginEvent")
      ) {
        dataLayer.push({
          event: "login",
          ...filteredUserDetails,
        });
        localStorage.setItem("loginEvent", true);
      }
    },
    controller: controller,
  });
}

// export function getConsumerBalance(payload = {
//   limit: 100,
//   offset: 0
// }) {
//   const controller = new AbortController();
//   return fetchData({
//     endpoint: "/consumer/balance",
//     payload,
//     successCallback: () => { },
//     controller: controller,
//   });
// }

// export async function getConsumerStats() {
//   const controller = new AbortController();
//   return fetchData({
//     endpoint: "/consumer/stats",
//     successCallback: () => { },
//     controller: controller,
//   });
// }// import { queryClient } from "../../../main";

export async function userDetailsUpdate(payload, successCallback) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/consumer/update",
    successCallback: successCallback,
    payload: payload,
    controller: controller,
  });
}

export async function updateEmailRequest(
  payload,
  successCallback,
  errorCallback
) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/consumer/update-email-request",
    successCallback: successCallback,
    errorCallback: errorCallback,
    payload: payload,
    controller: controller,
    shouldThrowError: false,
  });
}

export async function updateEmail(payload, successCallback, errorCallback) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/consumer/update-email",
    successCallback: successCallback,
    errorCallback: errorCallback,
    payload: payload,
    controller: controller,
    shouldThrowError: false,
  });
}

export async function updatePhoneRequest(payload) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/consumer/update-phone-request",
    payload: payload,
    controller: controller,
  });
}

export async function updatePhone(payload, successCallback) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/consumer/update-phone",
    successCallback: successCallback,
    payload: payload,
    controller: controller,
  });
}

export async function passwordResetToken(payload, successCallback) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/consumer/password-token",
    successCallback: data => {
      successCallback(data);
    },
    payload: payload,
    controller: controller,
  });
}

export function sendContactForm({
  payload,
  successCallback,
  shouldThrowError,
}) {
  return fetchData({
    endpoint: "/consumer/contact-form",
    successCallback: data => {
      successCallback(data);
      console.log(data, "data");
    },

    shouldThrowError,
    payload,
  });
}

export async function leaveBatClub(payload, successCallback) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/consumer/leave",
    successCallback: data => {
      successCallback(data);
    },
    payload: payload,
    controller: controller,
  });
}
